import { Options, Vue } from 'vue-class-component';

@Options({
	name: 'pageTitleComponent',
	props: {
		preTitle: String,
		mainTitle: String,
	},
})
export default class PageTitleComponent extends Vue {
	preTitle: string;
	mainTitle: string;

	public get showTitle() {
		return this.preTitle || this.mainTitle;
	}
}
